import React from 'react';
import { Link } from 'react-router-dom';
import Logo from '../images/Logo.png';
import CodingSuccessfully from '../images/coding-successfully.PNG';
import SinanSoft from '../images/Sinansoft.JPG';
import DaniImage from '../images/Dani.jpeg';
import JeissonImage from '../images/Jeisson.jpeg';
import SaeidImage from '../images/Saied.jpeg';
import '../styles/template.css';

const PartnersPage = () => {
  return (
    <div className="container">
      <header>
        <div className="logo-container">
          <img src={Logo} alt="Logo" className="logo" />
        </div>
        <h1>Partners</h1>
        <nav>
          <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/about">About</Link></li>
            <li><Link to="/partners">Partners</Link></li>
            <li><Link to="/connect">Meetups</Link></li>
            <li><Link to="/contact">Contact Us</Link></li>
          </ul>
        </nav>
      </header>

      <main>
        <h2 className="main-heading">Our Partners</h2>
        
        <section className="partners-intro">
          <p>
            We work with incredible people and organizations who believe in helping others 
            discover who they are and connect with experiences that actually matter.
          </p>
        </section>

        <section className="partners-grid">
          {/* Strategic Partners */}
          <div className="partner-category">
            <h3>Strategic Partners</h3>
            <div className="partner-cards">
              <div className="partner-card featured-partner">
                <div className="partner-logo">
                  <img src={CodingSuccessfully} alt="Coding Successfully Logo" />
                </div>
                <div className="partner-info">
                  <h4>Coding Successfully</h4>
                  <p>
                    Our creative and strategic partner bringing the Know Yourself vision to life. 
                    They handle digital strategy, marketing, and tech to help us build real connections 
                    that foster community and personal growth.
                  </p>
                  <a href="https://codingsuccessfully.com" target="_blank" rel="noopener noreferrer" className="partner-link">Visit Website</a>
                </div>
              </div>
            </div>
          </div>

          {/* Technology Partners */}
          <div className="partner-category">
            <h3>Technology Partners</h3>
            <div className="partner-cards">
              <div className="partner-card featured-partner">
                <div className="partner-logo">
                  <img src={SinanSoft} alt="SinanSoft Logo" />
                </div>
                <div className="partner-info">
                  <h4>SinanSoft Inc.</h4>
                  <p>
                    LA-based software development company making sure our tech can handle anything. 
                    They specialize in building platforms that scale, so we can grow with our community.
                  </p>
                  <a href="https://sinansoft.com/" target="_blank" rel="noopener noreferrer" className="partner-link">Visit Website</a>
                </div>
              </div>
            </div>
          </div>

          {/* Team Partners */}
          <div className="partner-category">
            <h3>Key Contributors</h3>
            <div className="partner-cards">
              <div className="partner-card">
                <div className="partner-profile">
                  <img src={SaeidImage} alt="Dr. Saeid Makhmali" className="profile-image" />
                </div>
                <div className="partner-info">
                  <h4>Dr. Saeid Makhmali – Founder & CEO of SinanSoft Inc.</h4>
                  <p>
                    Dr. Makhmali brings serious technical expertise from his time at Apple, UBS, and Luxoft. 
                    He helps us build a platform that's rock-solid and ready to scale as more people join 
                    the Know Yourself community.
                  </p>
                </div>
              </div>

              <div className="partner-card">
                <div className="partner-profile">
                  <img src={JeissonImage} alt="Jeisson Rueda" className="profile-image" />
                </div>
                <div className="partner-info">
                  <h4>Jeisson Rueda – Founder/CEO of Coding Successfully</h4>
                  <p>
                    Jeisson and Grant connected over a shared mission: helping people live more authentically. 
                    With Coding Successfully, Jeisson brings digital strategy and marketing expertise to grow 
                    Know Yourself into a platform that creates real connections and meaningful experiences.
                  </p>
                </div>
              </div>
              
              <div className="partner-card">
                <div className="partner-profile">
                  <img src={DaniImage} alt="Daniela Medina" className="profile-image" />
                </div>
                <div className="partner-info">
                  <h4>Daniela Medina – Consultant & Strategist at Coding Successfully</h4>
                  <p>
                    Daniela helps shape how Know Yourself tells its story and connects with people. 
                    Her background in strategy and creative direction keeps our messaging authentic 
                    and resonant with our community.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Partnership Opportunities */}
        <section className="partnership-cta">
          <h3>Want to Partner with Us?</h3>
          <p>
            We're looking for partners who share our values and want to help people 
            discover themselves and connect with their communities.
          </p>
          <Link to="/contact" className="cta-button">Get in Touch</Link>
        </section>
      </main>

      <footer>
        <p>&copy; 2026 Know Yourself LLC | All rights reserved.</p>
      </footer>
    </div>
  );
};

export default PartnersPage;
